import { render, staticRenderFns } from "./TestPassageProcessQuestion.vue?vue&type=template&id=8fc7659c&scoped=true&"
import script from "./TestPassageProcessQuestion.vue?vue&type=script&lang=js&"
export * from "./TestPassageProcessQuestion.vue?vue&type=script&lang=js&"
import style0 from "./TestPassageProcessQuestion.vue?vue&type=style&index=0&id=8fc7659c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc7659c",
  null
  
)

export default component.exports